import script from './component-lib.esm91.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 816.11 550.57"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'klaviyo'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M16.52,249.31,382.41,6.93c14.43-9.24,36.94-9.24,51.36,0l365.9,242.38c21.93,14.43,21.93,38.09,0,52.52l-49.06,32.32C678.47,220.46,551.51,145.43,407.8,145.43,263.53,145.43,137.14,221,65,334.15L15.94,301.83C-5.41,287.4-5.41,263.16,16.52,249.31Zm391.28-2.88c-109.07,0-204.29,57.71-258.54,143.12l84.26,56c35.78-58.86,99.84-98.11,173.71-98.11,73.29,0,137.93,39.25,173.71,98.11l84.26-56C612.68,304.14,516.88,246.43,407.8,246.43Zm0,202.57c-38.09,0-71.56,21.35-89.45,52.51l56.56,36.94c9.23,7.5,20.2,12.12,32.89,12.12a50.14,50.14,0,0,0,32.9-12.12l56.56-36.94C480.52,470.93,446.47,449,407.8,449Z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };